import { render, staticRenderFns } from "./Page-Stats.vue?vue&type=template&id=5b4f4b19&"
import script from "./Page-Stats.vue?vue&type=script&lang=js&"
export * from "./Page-Stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports